import { ApplicationConfig, Injectable, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { languageInterceptor } from './core/interceptors/language.interceptor';
import { refreshTokenInterceptor } from './core/interceptors/resfresh-token.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from './core/constants/date-formats';
import { missingPermissionsInterceptor } from './core/interceptors/missing_permissions.interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/yyyy',
  },
  display: {
    dateInput: 'DD/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = $localize`First page`;
  itemsPerPageLabel = $localize`Items per page:`;
  lastPageLabel = $localize`Last page`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = $localize`Next page`;
  previousPageLabel = $localize`Previous page`;

  getRangeLabel(page: number, pageSize: number, length: number): string {
    const pageLabel = $localize`:@@paginator-range-page:Page`;
    const ofLabel = $localize`:@@paginator-range-of:of`;
    const amountPages = Math.max(Math.ceil(length / pageSize), 1);
    return `${pageLabel} ${page + 1} ${ofLabel} ${amountPages}`;
  }
}



export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor, refreshTokenInterceptor, languageInterceptor, missingPermissionsInterceptor])
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    provideAnimationsAsync(),
    { provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl },
    provideCharts(withDefaultRegisterables()),
  ]
};
